import { render, staticRenderFns } from "./YachtSection.vue?vue&type=template&id=3bb60020"
import script from "./YachtSection.vue?vue&type=script&lang=js"
export * from "./YachtSection.vue?vue&type=script&lang=js"
import style0 from "./YachtSection.vue?vue&type=style&index=0&id=3bb60020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports